import axios from "axios";
import Env from "@/logics/Envs.js";

export default async function (userId) {
    try {
        const params = { userId };
        const res = await axios.get(Env.apiPath + "loadUserInfo", { params });
        return res.data.userInfo;
    } catch (err) {
        return null;
    }
}